var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.content)?_c('div',[_c('SimpleBreadcrumbs',{attrs:{"links":[
        {
          name: 'Головна сторінка',
          href: '/'
        },
        {
          name: 'Навчання',
          href: `/uk/profile/cosmobase`
        },
         {
          name: _vm.content ? _vm.content.title : 'Курс',
          href: `/uk/cosmobase-course/${ _vm.$route.params.id }`
        },
      ]}}),_c('ComsobaseCourseHero'),_c('ComsobaseCourseActions'),_c('ComsobaseCourseInfo'),_c('ComsobaseCourseCourseTitle'),_vm._l((_vm.content.blocks.data),function(course,index){return [(course.lessons.data.length > 0)?_c('ComsobaseCourseBlock',{attrs:{"course":course,"is-first":index === 0}}):_vm._e()]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }